import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'dark' | 'light';

/** Must match the key read by the pre-paint script in index.html. */
export const THEME_STORAGE_KEY = 'admin-theme-storage';

function applyTheme(theme: Theme) {
	document.documentElement.setAttribute('data-theme', theme);
}

interface ThemeState {
	theme: Theme;
	setTheme: (theme: Theme) => void;
	toggleTheme: () => void;
}

export const useThemeStore = create<ThemeState>()(
	persist(
		(set, get) => ({
			theme: 'light',
			setTheme: (theme: Theme) => {
				applyTheme(theme);
				set({ theme });
			},
			toggleTheme: () => get().setTheme(get().theme === 'dark' ? 'light' : 'dark'),
		}),
		{
			name: THEME_STORAGE_KEY,
			// The inline script in index.html already painted the correct theme
			// before first render; re-apply on rehydrate so the DOM and the
			// store can never drift (e.g. after a cross-tab storage change).
			onRehydrateStorage: () => (state) => {
				if (state) applyTheme(state.theme);
			},
		}
	)
);
